import React, { Component } from 'react';
import Link from 'next/link';
import FadeInAnimation from "../Common/FadeInAnimation";
import Image from 'next/image';
import { BiSolidEnvelope } from "react-icons/bi";
import { useTranslations } from '../../locales/useTranslations';

const BusinessAnalyticsHeader = () => {
    const { t } = useTranslations();
    return (
        <>
            <div className="mainbanner">
                <div className="business-analytics-banner">
                    <div className="container" >
                        <div className="business-analytics-banner-content">
                            <h1
                                data-aos="fade-up"
                                data-aos-delay="100"
                                data-aos-duration="1200"
                                dangerouslySetInnerHTML={{ __html: t("businessAnalytics_header_title") }}
                            />

                            <p className="banner-desc">
                                {t("businessAnalytics_header_description")}
                            </p>
                            <Link href="/kontakt" className="default-btn">
                                <BiSolidEnvelope /> {t("businessAnalytics_header_button")}
                            </Link>

                        </div>
                    </div>
                </div>
            </div >
        </>
    );
}
export default BusinessAnalyticsHeader;